<template>
  <v-dialog
    :value="previewImageDialog"
    @input="$emit('update:previewImageDialog', $event)"
    max-width="900"
    persistent
    @click:outside="$emit('close-preview-image')"
  >
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span>Image Preview</span>
        <v-btn icon @click="$emit('close-preview-image')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <img :src="previewImageSrc" alt="" style="width: 100%; height: auto; display: block" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ImagePreviewDialog',
  props: {
    previewImageDialog: { type: Boolean, required: true },
    previewImageSrc: { type: String, default: '' },
  },
};
</script>

<style scoped lang="scss"></style>
